import styled from "styled-components";

import StatusBadge from "./StatusBadge";
import { RESERVATION_META, PHYSICAL_STATUS_META, FOOTER_META } from "./status";
import { useT } from "./i18n";

const Wrap = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem 1.5rem;
  padding: 0.75rem 1rem;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
`;

const Group = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.4rem;
`;

const Title = styled.span`
  font-size: 0.75rem;
  font-weight: 700;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.03em;
`;

const FooterChip = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  padding: 0.15rem 0.45rem;
  border-radius: 6px;
  font-size: 0.75rem;
  font-weight: 700;
  color: ${(props) => props.$fg};
  background: ${(props) => props.$bg};
`;

const FOOTER_ITEMS = ["CI", "Stay", "CO", "Early CO", "Transit"];

const Legend = (props) => {
  const { t } = useT();
  return (
    <Wrap>
      <Group>
        <Title>{t("legend_physical")}</Title>
        {Object.values(PHYSICAL_STATUS_META).map((meta) => (
          <StatusBadge key={meta.labelKey} meta={meta} variant="soft" />
        ))}
      </Group>
      <Group>
        <Title>{t("legend_booking")}</Title>
        {[
          RESERVATION_META.reserved,
          RESERVATION_META.available,
          RESERVATION_META.blocked,
        ].map((meta) => (
          <StatusBadge key={meta.labelKey} meta={meta} variant="outline" />
        ))}
      </Group>
      <Group>
        <Title>{t("legend_activity")}</Title>
        {FOOTER_ITEMS.map((label) => {
          const meta = FOOTER_META[label];
          const Icon = meta.Icon;
          return (
            <FooterChip key={label} $bg={meta.bg} $fg={meta.fg}>
              <Icon size={12} aria-hidden="true" />
              {label}
            </FooterChip>
          );
        })}
      </Group>
    </Wrap>
  );
};

export default Legend;
